var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318.191,
    height: 152.208,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -11.7,
    y1: 0.834,
    x2: -11.775,
    y2: 1.064,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.501,
    y1: 1.318,
    x2: 0.499,
    y2: -0.551,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#510394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#4a0387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "#370367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#1a0332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#030408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: -0.204,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7618ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#7618ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#5d07cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#3d018b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -0.295,
    y1: 2.499,
    x2: -1.193,
    y2: 3.392,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bfad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#f2dad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.193,
    y1: 0.565,
    x2: 0.875,
    y2: 0.381,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d0633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192b59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 1.098,
    y1: 0.752,
    x2: 0.222,
    y2: 0.436,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.413,
    y1: 0.074,
    x2: 0.338,
    y2: 0.3,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bfad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2dad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.501,
    y1: 1.092,
    x2: 0.498,
    y2: -0.261,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -0.017,
    y1: 0.498,
    x2: 0.982,
    y2: 0.498,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c8bf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.992,
    y1: 0.301,
    x2: 0.183,
    y2: 0.757,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2be3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2c508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.461,
    y1: 0.009,
    x2: 0.559,
    y2: 0.672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -0.498,
    y1: 1.016,
    x2: 0.464,
    y2: 0.6,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 1.018,
    y1: 1.053,
    x2: 0.104,
    y2: 0.383,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 1.092,
    y1: 0.319,
    x2: 0.22,
    y2: 0.567,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e9cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176ad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.543,
    y1: 0.299,
    x2: 0.374,
    y2: 1.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2be3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffac00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9263"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9102",
    d: "M58.02 136.601c34.013 5.886 44.535-33.066 90.882-38.334 53.966-6.135 76.863 42.452 113.71 31.443 41.347-12.354 70.57-90.878 47.379-119.74-28.378-35.317-110.319 34.735-258.863 32.3-15.917-.261-40.269-1.479-48.241 12.06-12.576 21.364 17.772 75.807 55.133 82.271Z",
    fill: "rgba(28,139,249,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9259"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9245",
    transform: "translate(53.503 147.177)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1463",
    cx: 96.846,
    cy: 2.516,
    rx: 96.846,
    ry: 2.516,
    transform: "translate(61.695)",
    opacity: 0.1,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9103",
    d: "M470.865 698.907c0 1.025-11.582 1.857-25.869 1.857s-25.869-.831-25.869-1.857 11.582-1.857 25.873-1.857 25.865.831 25.865 1.857Z",
    transform: "translate(-419.127 -696.391)",
    opacity: 0.1,
    fill: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9247",
    transform: "translate(97.113 36.072)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9104",
    d: "M102.877 112.266H55.665a.716.716 0 0 0 .4 1.217h46.4a.723.723 0 0 0 .412-1.217Z",
    fill: "#030408"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4375",
    d: "M11.081 0h136.393a11.081 11.081 0 0 1 11.081 11.081v69.214a11.082 11.082 0 0 1-11.082 11.082H11.082A11.082 11.082 0 0 1 0 80.295V11.081A11.081 11.081 0 0 1 11.081 0Z",
    fill: "#7618ef"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4376",
    width: 155.314,
    height: 87.256,
    rx: 8.942,
    transform: "translate(1.621 1.644)",
    fill: "#fdffff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9105",
    d: "M781.125 653.122c-1.671-1.244-4.61-3.454-5.549-4.3-1.34-1.21-2.2-16.474-2.2-16.474h-31.487s-.864 15.264-2.2 16.474c-.94.849-3.879 3.059-5.549 4.3a.49.49 0 0 0 .294.883h46.4a.49.49 0 0 0 .291-.883Z",
    transform: "translate(-678.353 -540.97)",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9246",
    transform: "translate(24.459 10.889)",
    fill: "#f0dbfc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9106",
    d: "M127.559 10.349h-7.014v-7.6A2.752 2.752 0 0 0 117.796 0H2.745A2.752 2.752 0 0 0-.004 2.749v62.743a2.752 2.752 0 0 0 2.749 2.749h115.053a2.752 2.752 0 0 0 2.747-2.749v-53.96h7.012a.592.592 0 0 0 0-1.183Zm-9.761 56.71H2.745a1.568 1.568 0 0 1-1.566-1.566V2.749a1.568 1.568 0 0 1 1.566-1.566h115.053a1.568 1.568 0 0 1 1.566 1.566v7.6H40.791a.592.592 0 0 0 0 1.183h78.572v53.96a1.567 1.567 0 0 1-1.565 1.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9107",
    d: "M100.409 7.853a1.911 1.911 0 1 0-1.911-1.911 1.914 1.914 0 0 0 1.911 1.911Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1464",
    cx: 1.911,
    cy: 1.911,
    r: 1.911,
    transform: "translate(104.932 4.031)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9108",
    d: "M113.275 7.853a1.911 1.911 0 1 0-1.911-1.911 1.913 1.913 0 0 0 1.911 1.911Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9109",
    d: "M51.199 17.956H9.619a.592.592 0 0 0-.591.591v41.578a.592.592 0 0 0 .591.592h41.58a.592.592 0 0 0 .591-.592V18.547a.592.592 0 0 0-.591-.591ZM10.212 59.534v-40.4h40.4v40.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9110",
    d: "M110.681 34.87a.592.592 0 0 0-.591.591v.856h-.856a.592.592 0 0 0 0 1.183h1.448a.592.592 0 0 0 .592-.591v-1.448a.592.592 0 0 0-.593-.591Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9111",
    d: "M103.579 37.5h2.826a.592.592 0 1 0 0-1.183h-2.826a.592.592 0 1 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9112",
    d: "M95.105 36.317h-2.826a.592.592 0 1 0 0 1.183h2.826a.592.592 0 1 0 0-1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9113",
    d: "M97.931 37.5h2.826a.592.592 0 1 0 0-1.183h-2.826a.592.592 0 1 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9114",
    d: "M75.325 37.5h2.826a.592.592 0 1 0 0-1.183h-2.826a.592.592 0 1 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9115",
    d: "M83.802 36.317h-2.826a.592.592 0 1 0 0 1.183h2.826a.592.592 0 1 0 0-1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9116",
    d: "M90.045 36.908a.592.592 0 0 0-.592-.591h-2.822a.592.592 0 0 0 0 1.183h2.826a.592.592 0 0 0 .588-.592Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9117",
    d: "M69.672 37.5h2.826a.592.592 0 0 0 0-1.183h-2.826a.592.592 0 1 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9118",
    d: "M66.847 36.317h-2.826a.592.592 0 0 0 0 1.183h2.826a.592.592 0 0 0 0-1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9119",
    d: "M59.749 37.497h1.448a.592.592 0 1 0 0-1.183h-.856v-.856a.592.592 0 1 0-1.183 0v1.448a.592.592 0 0 0 .591.591Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9120",
    d: "M59.749 26.773a.592.592 0 0 0 .592-.592v-3.089a.592.592 0 0 0-1.183 0v3.093a.592.592 0 0 0 .591.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9121",
    d: "M59.749 32.959a.593.593 0 0 0 .592-.592v-3.093a.592.592 0 0 0-1.183 0v3.093a.592.592 0 0 0 .591.592Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9122",
    d: "M59.749 20.587a.592.592 0 0 0 .591-.592v-.856h.856a.592.592 0 0 0 0-1.183h-1.447a.592.592 0 0 0-.591.591v1.448a.592.592 0 0 0 .591.592Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9123",
    d: "M69.672 19.139h2.826a.592.592 0 0 0 0-1.183h-2.826a.592.592 0 0 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9124",
    d: "M64.021 19.139h2.826a.592.592 0 0 0 0-1.183h-2.826a.592.592 0 0 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9125",
    d: "M103.579 19.139h2.825a.592.592 0 1 0 0-1.183h-2.825a.592.592 0 1 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9126",
    d: "M92.28 19.139h2.826a.592.592 0 0 0 0-1.183H92.28a.592.592 0 1 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9127",
    d: "M86.632 19.139h2.826a.592.592 0 0 0 0-1.183h-2.826a.592.592 0 0 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9128",
    d: "M97.93 19.139h2.826a.592.592 0 0 0 0-1.183H97.93a.592.592 0 0 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9129",
    d: "M75.324 19.139h2.826a.592.592 0 1 0 0-1.183h-2.826a.592.592 0 0 0 0 1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9130",
    d: "M83.801 17.956h-2.826a.592.592 0 0 0 0 1.183h2.826a.592.592 0 1 0 0-1.183Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9131",
    d: "M110.681 17.956h-1.448a.592.592 0 0 0 0 1.183h.856v.856a.592.592 0 1 0 1.183 0v-1.448a.592.592 0 0 0-.591-.591Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9132",
    d: "M110.681 28.683a.592.592 0 0 0-.591.591v3.093a.592.592 0 1 0 1.183 0v-3.093a.592.592 0 0 0-.592-.591Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9133",
    d: "M110.681 22.492a.592.592 0 0 0-.591.591v3.093a.592.592 0 1 0 1.183 0v-3.084a.592.592 0 0 0-.592-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9134",
    d: "M82.205 41.173H59.749a.592.592 0 0 0-.591.591v18.362a.592.592 0 0 0 .591.592h22.456a.592.592 0 0 0 .591-.592V41.764a.592.592 0 0 0-.591-.591ZM60.34 59.534V42.356h21.273v17.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9135",
    d: "M110.197 41.173H87.741a.592.592 0 0 0-.592.591v18.362a.592.592 0 0 0 .592.592h22.456a.592.592 0 0 0 .592-.592V41.764a.592.592 0 0 0-.592-.591ZM88.332 59.534V42.356h21.273v17.178Z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9248",
    transform: "translate(237.245 59.073)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4377",
    width: 41.134,
    height: 52.69,
    rx: 8,
    fill: "#e8d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4378",
    fill: "#fff",
    d: "M7.404 12.676h23.283v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4379",
    fill: "#fff",
    d: "M7.404 16.04h23.283v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4380",
    fill: "#fff",
    d: "M7.404 19.403h15.522v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4381",
    fill: "#fff",
    d: "M7.404 22.766h23.283v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4382",
    fill: "#fff",
    d: "M7.404 26.129h15.522v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4383",
    fill: "#fff",
    d: "M7.404 29.492h23.283v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4384",
    fill: "#fff",
    d: "M7.404 32.855h15.522v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4385",
    fill: "#fff",
    d: "M7.404 36.218h23.283v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4386",
    fill: "#fff",
    d: "M7.404 39.581h15.522v1.035H7.404z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4387",
    width: 12.935,
    height: 3.363,
    rx: 1.682,
    transform: "translate(7.404 6.468)",
    fill: "#9909b7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9250",
    transform: "translate(80.525 16.722)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4388",
    width: 49.649,
    height: 46.302,
    rx: 8,
    fill: "#e8d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4389",
    fill: "#9909b7",
    d: "M3.626 33.471h25.103v1.116H3.626z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4390",
    fill: "#9909b7",
    d: "M3.626 37.097h16.736v1.116H3.626z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4391",
    width: 8.926,
    height: 8.926,
    rx: 4.463,
    transform: "translate(38.213 34.866)",
    fill: "#9909b7"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9249"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9164",
    d: "M8 0h33.649a8 8 0 0 1 8 8v22.124H0V8a8 8 0 0 1 8-8Z",
    fill: "#3d9eff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9136",
    d: "M0 15.517s7.163 8.848 15.941 8.146 12.231-6.37 19.761-6.37c9.763 0 13.946 3 13.946 3v9.832H0Z",
    fill: "#1c8bf9"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1465",
    cx: 2.51,
    cy: 2.51,
    r: 2.51,
    transform: "rotate(-88.453 11.411 1.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4393",
    fill: "#0051a1",
    opacity: 0.6,
    d: "M19.804 16.736h3.068v1.395h-3.068z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4394",
    fill: "#0051a1",
    opacity: 0.6,
    d: "m25.616 4.205 2.372 1.948-.886 1.079-2.372-1.949z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4395",
    fill: "#0051a1",
    opacity: 0.6,
    d: "m45.593 5.145 2.804-1.243.565 1.275-2.804 1.243z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4396",
    fill: "#0051a1",
    opacity: 0.6,
    d: "M2.679 1.244 3.9 4.057l-1.28.556L1.4 1.799z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9252",
    transform: "translate(110.195 26.357)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4397",
    width: 58.904,
    height: 15.596,
    rx: 7.798,
    fill: "#e8d6ff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9251",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4398",
    d: "M7.29 3.808h44.323v1.064H7.29z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4399",
    d: "M7.29 7.266h44.323V8.33H7.29z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4400",
    d: "M7.29 10.724h29.549v1.064H7.29z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9257"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9254"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9253"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9137",
    d: "M218.962 77.655a16.02 16.02 0 0 1-2.082-4.5 3.594 3.594 0 0 1 2.465-4.113 3.838 3.838 0 0 1 4.122.9c.678.74.744 1.892.959 3.769.242 2.11-5.464 3.944-5.464 3.944Z",
    fill: "#e64d4e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9138",
    d: "M943.353 471.518a8.915 8.915 0 0 1 .479 1.815 29.082 29.082 0 0 0 .047 2.953 8.686 8.686 0 0 0 3.284 1.027 3.523 3.523 0 0 0 2.034-1.679 20.76 20.76 0 0 1-.363-2.409c.043-.246-4.725-2.063-5.481-1.707Z",
    transform: "translate(-724.669 -394.713)",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9139",
    d: "M221.806 71.076c1.213-.333 1.961.045 2.1.469s.827 3.028 1.009 3.558.157 3.562-.895 3.881-3.247.14-4.036-.847a6.048 6.048 0 0 0-1.481-1.454c-.234-.148-1.109-1.127-1.038-1.534s.287-.7.551-.55a2.914 2.914 0 0 1 .954 1.007c.1.22-.309-3.155.428-3.585a16.407 16.407 0 0 1 2.408-.945Z",
    fill: "#f2dad4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9140",
    d: "M982.075 691.764c.412.684 1.765 2.6 2.052 3.06s.6 1.275.39 1.323a7.086 7.086 0 0 1-2.613.307c-1.174-.145-2.435-.509-2.57-.894s-.048-1.113-.315-1.181a4.608 4.608 0 0 1-1.4-.25c-.457-.25-.6-.328-.594-.494a7.79 7.79 0 0 1 .026-1.815c.144-.383 5.024-.056 5.024-.056Z",
    transform: "translate(-747.698 -545.503)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9141",
    d: "M924.624 692.546c-.342.345-3.48 2.986-3.749 3.444a.946.946 0 0 0-.015 1.062 3.6 3.6 0 0 0 2.019.367c.964-.1 2.844-.458 3.39-1.113s.938-1.34 1.165-1.307a1.78 1.78 0 0 0 1.263.17 4.214 4.214 0 0 0 1.449-.615 3.919 3.919 0 0 0-.04-1.448 54.486 54.486 0 0 0-5.482-.56Z",
    transform: "translate(-709.161 -546.128)",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9142",
    d: "M215.559 105.487a71.988 71.988 0 0 0-.619 9.725c.133 2.92 1.51 11.969 1.322 14.532s.239 11.566-.187 12.849a17.168 17.168 0 0 0-.813 4.076 9.209 9.209 0 0 0 3.507.919 4.473 4.473 0 0 0 2.315-.475c.173-.252-.331-5.232-.061-7.434s1.081-7.791 1.081-9 .765-10.868.807-11.566.106-2.979.354-2.992 1.155 3.852 1.315 4.615 2.83 9.044 3.139 13.219 1 9.442.937 9.99.613 3.235 1.556 3.29a13.136 13.136 0 0 0 2.962-.552c.6-.114 1.4-.015 1.444-.339s-1.326-4.135-1.427-4.656.376-6.449.1-8.251-1.011-4.91-1.173-5.692.087-7.471.087-8.966-1.078-11.93-1.872-13.082-14.774-.21-14.774-.21Z",
    fill: "#192b59"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9143",
    d: "M890.393 417.4c-.194.491.452 2.07.644 2.439a28.935 28.935 0 0 1 .675 4.034 6.132 6.132 0 0 0 .06 1.349 3.1 3.1 0 0 0 1.728.451 1.217 1.217 0 0 0 1.007-1.115 45.315 45.315 0 0 0-.385-2.117 4.762 4.762 0 0 1 .026-2.488c.282-.3 1.4-1.021 1.457-1.357a4.971 4.971 0 0 0-.219-2.073c-.236-.284-.916.023-1.071.038s-.451.19-.423.346.388.435.483.449.208.051.206.164-.176.219-.254.205.076-.4-.41-.4a23.957 23.957 0 0 1-2.705-.423 1.034 1.034 0 0 0-.819.498Z",
    transform: "translate(-688.372 -356.995)",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9144",
    d: "M999.671 408.524a5.315 5.315 0 0 1-.2 2.514 28.87 28.87 0 0 0 .048 4.09 6.137 6.137 0 0 1 .18 1.338 3.1 3.1 0 0 1-1.621.75 1.217 1.217 0 0 1-1.189-.92 44.434 44.434 0 0 1 .006-2.152 4.762 4.762 0 0 0-.465-2.444c-.331-.249-1.561-.757-1.674-1.078a4.968 4.968 0 0 1-.151-2.079c.183-.321.906-.14 1.062-.152s.477.108.478.266a.989.989 0 0 1-.4.527c-.092.03-.2.087-.175.2a.271.271 0 0 0 .286.157c.074-.027-.144-.377.333-.47a23.93 23.93 0 0 0 2.588-.895 1.034 1.034 0 0 1 .894.348Z",
    transform: "translate(-759.722 -351.348)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9145",
    d: "M890.831 437.662c-.15 1 1.655 4.743 1.934 5.552s2.428 5.383 2.692 5.7a44.735 44.735 0 0 1 3.419 3.361 37.067 37.067 0 0 0 3.754 3.411c.419.431 1.392 3.278 1.263 7.08s-1.368 12.437-1.15 12.625 5.645-.123 8.6-.043 10.194.5 10.386-.013-3.253-12.135-3.263-13.945.8-6.452 1.733-7.4 6.58-6.228 7.481-8.388 1.8-10.426 1.728-11.161-3.773-.739-3.941-.361-.511 6.4-1.126 7.532-3.95 6.22-4.686 6.427-4.809 1.751-5.43 1.5-.63-1.656-1.02-1.646-.448.743-1.011.8-.462.649-.471 1.258-.737 1.3-1.095 1.186-1.286-1.783-1.815-1.947a1.471 1.471 0 0 0-1.3.106c-.174.2-.334.417-.705.177a18.52 18.52 0 0 0-3.773-.461 1.885 1.885 0 0 1-1.593-1.023c-.426-.8-3.323-3.421-3.382-3.7s-1.4-3.268-1.6-3.959-.783-3.63-1.225-3.828a6.112 6.112 0 0 0-2.531.088c-.671.156-1.831.79-1.873 1.072Z",
    transform: "translate(-688.69 -368.935)",
    fill: "url(#j)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9146",
    d: "M547.391 495.054c-28.049 0-37.358-16.629-38.362-25.422-.756-6.629.2-11.425 2.922-14.661 2.488-2.957 6.532-4.558 12.189-4.889v2.908c-4.884.285-7.994 1.505-9.967 3.85-2.181 2.593-2.92 6.669-2.259 12.462.9 7.9 9.477 22.847 35.476 22.847 9.949 0 17.181-2.55 22.761-8.024 5.141-5.043 8.477-12 12.34-20.06 5.592-11.665 11.931-24.886 25.818-36.262a109.211 109.211 0 0 1 26.376-15.9 1.452 1.452 0 1 1 1.14 2.671 106.322 106.322 0 0 0-25.675 15.473c-13.387 10.967-19.578 23.879-25.04 35.27-3.816 7.959-7.42 15.476-12.924 20.877-6.158 6.046-14.037 8.86-24.795 8.86Z",
    transform: "translate(-427.027 -353.837)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9147",
    d: "M1016.97 497.19a10.222 10.222 0 0 1-1.023-.051c-4.1-.412-8.078-3.449-11.517-8.783a56.02 56.02 0 0 1-5.255-11.216h3.046c3.793 10.225 8.874 16.592 14.016 17.109 3.2.322 6.985-1.586 10.661-5.374a46.706 46.706 0 0 0 9.883-16.722 45.765 45.765 0 0 0 2.593-20.931c-1.291-9.862-7-19.485-16.065-27.1-9.424-7.911-21.731-13.271-35.592-15.5a1.452 1.452 0 0 1 .461-2.867c14.379 2.314 27.173 7.9 37 16.145 9.627 8.081 15.692 18.361 17.077 28.945 2 15.258-5.164 31.7-13.272 40.053-4.014 4.134-8.144 6.292-12.013 6.292Z",
    transform: "translate(-754.217 -349.691)",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9148",
    d: "M892.656 415.28c.23-.132.463-.535.672-.547s.228.038.293 0 .221-.4.476-.452a1.44 1.44 0 0 1 .5.04c.041-.019.1-.305.358-.288s.3.2.363.175.3-.211.477-.1a.945.945 0 0 1 .357.568c0 .128.024 1.068-.193 1.123a.728.728 0 0 1-.489.026c-.084-.06-.181.33-.377.32s-.337-.122-.409-.11-.062.267-.343.262-.408-.2-.48-.2-.166.213-.446.189-.435-.124-.432-.313.058-.4-.053-.425-.274-.268-.274-.268Z",
    transform: "translate(-689.947 -355.376)",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9149",
    d: "M1000.7 406.361c-.25-.089-.55-.444-.758-.42s-.217.078-.288.056-.288-.352-.549-.36a1.431 1.431 0 0 0-.485.128c-.043-.012-.156-.282-.4-.221s-.263.251-.326.236-.329-.155-.487-.011a.944.944 0 0 0-.251.622c.024.126.165 1.055.388 1.072a.73.73 0 0 0 .487-.061c.072-.074.236.293.427.249s.31-.18.383-.181.108.251.384.2.366-.271.436-.284.2.18.472.107.406-.2.371-.384-.127-.381-.023-.427.219-.321.219-.321Z",
    transform: "translate(-761.513 -349.553)",
    fill: "url(#m)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9256"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9255",
    fill: "#192b59"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9150",
    d: "m218.245 54.356-3.115 1.033a.512.512 0 0 1-.646-.324.511.511 0 0 1 .325-.647l3.115-1.034a.512.512 0 0 1 .647.325.512.512 0 0 1-.326.647Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9151",
    d: "m219.38 57.776-3.115 1.033a.511.511 0 0 1-.646-.324.511.511 0 0 1 .324-.647l3.11-1.033a.511.511 0 0 1 .646.324.512.512 0 0 1-.319.647Z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9152",
    d: "m216.007 61.538-2.875.954a4.823 4.823 0 0 1-6.1-3.059 4.823 4.823 0 0 1 3.059-6.1l2.875-.954Z",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9153",
    d: "M216.778 61.985a.591.591 0 0 1-.747-.375l-3.084-9.3a.591.591 0 0 1 .375-.747.591.591 0 0 1 .747.375l3.084 9.3a.591.591 0 0 1-.375.747Z",
    fill: "#ffac00"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9154",
    d: "m228.27 51.555 2.971.591a4.823 4.823 0 0 1 3.788 5.672 4.823 4.823 0 0 1-5.672 3.788l-2.971-.591Z",
    fill: "#ffac00"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9258",
    transform: "translate(59.124 71.073)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4401",
    width: 53.996,
    height: 42.293,
    rx: 8,
    fill: "#e8d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4402",
    fill: "#9909b7",
    d: "M3.724 2.926H19.95V5.32H3.724z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4403",
    width: 47.347,
    height: 23.939,
    rx: 6,
    transform: "translate(3.724 8.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4404",
    fill: "#d3d6db",
    d: "M6.384 16.226h23.939v1.064H6.384z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4405",
    fill: "#d3d6db",
    d: "M6.384 19.683h23.939v1.064H6.384z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4406",
    fill: "#d3d6db",
    d: "M6.384 23.141h15.96v1.064H6.384z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4407",
    width: 8.512,
    height: 8.512,
    rx: 4.256,
    transform: "translate(39.101 21.013)",
    fill: "#9909b7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9155",
    d: "M17.957 13.3H8.115a1.729 1.729 0 0 1-1.729-1.729 1.729 1.729 0 0 1 1.729-1.729h9.842a1.729 1.729 0 0 1 1.729 1.729 1.729 1.729 0 0 1-1.729 1.729Z",
    fill: "#9909b7"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9262"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9260"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9156",
    d: "M472.1 556.751c1.453.378 6.957.157 5.906-2.56-1.169-3.02-4.289-.38-5.628 1.294a37.525 37.525 0 0 0 .57-6.847c.989-1.189 3.08-8.743-1.038-8.369-5.4.491-.615 7.641.628 8.453a34.678 34.678 0 0 1-.906 8.19c-.168-1.9-2.066-7.317-4.589-5.408-3.66 2.769 3.343 6.112 4.4 6.055a10.394 10.394 0 0 1-1.329 2.905 54.51 54.51 0 0 0-1.32 1.982l-.025.027c-.235-2-2.105-7.151-4.575-5.282-3.417 2.585 2.46 5.67 4.12 6.022a47.6 47.6 0 0 0-2.909 5.433c-.115-1.81-3.667-5.51-5.077-3.394-.786 1.18 3.376 5.024 4.748 4.163a11 11 0 0 0-1.091 5c.06.481.148 1.048.25 1.662-.972-1.075-4.485-4.681-5.532-1.891-.868 2.314 2.031 3.656 3.25 3.656a4.029 4.029 0 0 0 2.361-1.3l.175 1.024a40.665 40.665 0 0 1 .906 8.336c-.83-1.61-4.536-8.312-6.692-4-1.105 2.21 2.031 4.062 3.25 4.468a8.382 8.382 0 0 0 3.4-.085 3.759 3.759 0 0 1-.139.63 23.979 23.979 0 0 1-2.414 4.826.2.2 0 1 0 .338.225 26.288 26.288 0 0 0 2.059-3.863c.957-.121 4.636-.622 5.693-1.327 1.219-.812 3.4-3.482 1.625-4.468-2.748-1.527-5.629 2.531-6.891 4.641.47-1.575.054-4.725-.435-7.684a9.92 9.92 0 0 0 5.295-1.02c1.219-.812 3.319-2.917 2.031-4.062-3.229-2.871-6.641 3.21-7.394 4.669-.077-.46-.155-.914-.231-1.354-.2-1.18-.4-2.294-.5-3.138a10.884 10.884 0 0 1 1.1-4.9 12.409 12.409 0 0 0 5.194.462c2.843-.406 4.285-2.62 3.25-3.656-1.763-1.763-6.971 1.889-8.318 2.885a45.119 45.119 0 0 1 3.229-6.039c1.657.384 8.259.243 7.366-2.379s-4.272-.857-6.258.679c.164-.241.327-.482.492-.717a12.091 12.091 0 0 0 1.655-3.944Z",
    transform: "translate(-392.573 -441.825)",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9157",
    d: "M433.367 618.542c-3.41-1.364-4.243 3.855-4.423 5.566a20.068 20.068 0 0 1-.73-8.006 10.547 10.547 0 0 0 3.935-.81c1.625-.813 2.627-4.066 1.218-4.469-2.366-.676-4.449 3.426-5.083 4.824.056-.315.122-.621.2-.912a36.249 36.249 0 0 0 1.057-6.759 14.324 14.324 0 0 0 3.419-.4c1.219-.406 3.282-3.589 1.625-4.062-2.284-.653-4.3 2.623-5.012 3.939a23.443 23.443 0 0 0-.394-6.575 16.043 16.043 0 0 0 .531-3.458c0-1.625-1.886-4.823-3.656-3.25-3.234 2.875 1.612 6.235 2.774 6.972a23.653 23.653 0 0 1 .339 6.393c-.726-1.828-3.66-8.4-7.175-5.24-1.35 1.215 1.625 4.062 3.656 4.875a11.568 11.568 0 0 0 3.491.812 35.96 35.96 0 0 1-1.047 6.65 10.584 10.584 0 0 0-.228 1.072c-.77-1.554-4.354-8.161-8.31-5.284-1.643 1.194 1.625 4.062 3.25 4.875 1.395.7 4.234.734 5.011.73a20.517 20.517 0 0 0 .7 8.007c-1.194-1.805-4.683-6.44-7.335-3.457-1.574 1.771 2.5 3.271 3.656 3.656a18.608 18.608 0 0 0 3.885.465A8.912 8.912 0 0 0 431 628.65a.2.2 0 1 0 .26-.312 8.51 8.51 0 0 1-2.177-3.78 20.844 20.844 0 0 0 3.063-1.548c1.221-.81 3.107-3.71 1.221-4.468Z",
    transform: "translate(-365.61 -478.46)",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9158",
    d: "M76.49 150.237H58.007a.203.203 0 1 1 0-.406H76.49a.203.203 0 1 1 0 .406Z",
    fill: "#7500b2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9159",
    d: "M82.993 150.237h-4.265a.203.203 0 1 1 0-.406h4.265a.203.203 0 1 1 0 .406Z",
    fill: "#7500b2"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9261"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9160",
    d: "M1193.2 595.9c1.068.278 5.116.115 4.343-1.882-.86-2.22-3.154-.279-4.138.952a27.617 27.617 0 0 0 .419-5.035c.728-.874 2.265-6.429-.763-6.153-3.968.361-.453 5.618.462 6.215a25.506 25.506 0 0 1-.666 6.022c-.123-1.4-1.519-5.381-3.374-3.977-2.691 2.036 2.458 4.495 3.239 4.452a7.638 7.638 0 0 1-.977 2.136c-.3.426-.629.92-.97 1.458l-.018.02c-.173-1.473-1.548-5.258-3.364-3.884-2.513 1.9 1.809 4.17 3.03 4.428a35.016 35.016 0 0 0-2.139 3.995c-.085-1.331-2.7-4.051-3.734-2.5-.578.867 2.482 3.694 3.491 3.061a8.087 8.087 0 0 0-.8 3.678c.044.354.109.77.183 1.222-.715-.791-3.3-3.442-4.068-1.39-.638 1.7 1.494 2.688 2.39 2.688a2.964 2.964 0 0 0 1.736-.953l.129.753a29.878 29.878 0 0 1 .666 6.13c-.61-1.184-3.336-6.112-4.921-2.943-.812 1.625 1.494 2.987 2.39 3.286a6.172 6.172 0 0 0 2.5-.062 2.791 2.791 0 0 1-.1.463 17.624 17.624 0 0 1-1.775 3.549.149.149 0 0 0 .248.166 19.309 19.309 0 0 0 1.514-2.841 15.4 15.4 0 0 0 4.186-.976c.9-.6 2.5-2.56 1.195-3.286-2.02-1.123-4.139 1.861-5.067 3.413.345-1.158.04-3.475-.319-5.65a7.29 7.29 0 0 0 3.893-.75c.9-.6 2.441-2.145 1.494-2.987-2.375-2.111-4.884 2.36-5.437 3.433l-.17-1c-.149-.867-.29-1.687-.368-2.307a8 8 0 0 1 .812-3.607 9.118 9.118 0 0 0 3.819.34c2.091-.3 3.151-1.927 2.39-2.688-1.3-1.3-5.126 1.389-6.116 2.122a33.15 33.15 0 0 1 2.374-4.44c1.219.282 6.073.178 5.416-1.749s-3.141-.63-4.6.5c.12-.177.241-.354.362-.527a8.892 8.892 0 0 0 1.203-2.895Z",
    transform: "translate(-888.932 -471.632)",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9161",
    d: "M1164.725 641.34c-2.507-1-3.12 2.835-3.252 4.093a14.758 14.758 0 0 1-.537-5.887 7.753 7.753 0 0 0 2.893-.6c1.195-.6 1.932-2.99.9-3.285-1.74-.5-3.272 2.519-3.737 3.547.041-.232.089-.457.148-.671a26.677 26.677 0 0 0 .777-4.97 10.541 10.541 0 0 0 2.514-.3c.9-.3 2.413-2.639 1.195-2.987-1.679-.48-3.165 1.929-3.685 2.9a17.251 17.251 0 0 0-.29-4.834 11.81 11.81 0 0 0 .391-2.543c0-1.195-1.387-3.547-2.689-2.39-2.378 2.114 1.186 4.585 2.04 5.127a17.407 17.407 0 0 1 .249 4.7c-.534-1.344-2.691-6.18-5.276-3.853-.993.894 1.195 2.987 2.688 3.584a8.493 8.493 0 0 0 2.567.6 26.415 26.415 0 0 1-.77 4.89 7.857 7.857 0 0 0-.168.788c-.566-1.143-3.2-6-6.11-3.885-1.208.879 1.194 2.987 2.389 3.584a10.364 10.364 0 0 0 3.685.537 15.084 15.084 0 0 0 .514 5.888c-.878-1.328-3.443-4.736-5.394-2.542-1.157 1.3 1.838 2.4 2.688 2.688a13.659 13.659 0 0 0 2.857.342 6.555 6.555 0 0 0 1.677 2.909.149.149 0 1 0 .191-.229 6.257 6.257 0 0 1-1.6-2.779 15.324 15.324 0 0 0 2.252-1.138c.893-.596 2.28-2.73.893-3.284Z",
    transform: "translate(-869.107 -498.569)",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9162",
    d: "M302.04 150.238h-13.591a.15.15 0 1 1 0-.3h13.591a.15.15 0 0 1 0 .3Z",
    fill: "#7500b2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9163",
    d: "M306.82 150.238h-3.136a.15.15 0 1 1 0-.3h3.136a.15.15 0 1 1 0 .3Z",
    fill: "#7500b2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataConfig);
export default __webpack_public_path__ + "static/media/no_data-config.def9d1d29b3f6480a490a3eb3ead0747.svg";
export { ForwardRef as ReactComponent };